import { Backdrop, Container } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { setYorumAdet } from 'src/utils/storage/NavBarAdet';
import Header from 'src/components/Header';
import ConversationDetails from './ConversationDetails';
import ConversationList from './ConversationList';
import ConversationPlaceholder from './ConversationPlaceholder';
import { isProduction } from 'src/utils/contants';
import avatar from 'src/assets/images/technician.png';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '90%',
    display: 'flex',
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    overflow: 'hidden',
    '@media (max-width: 863px)': {
      '& $conversationList, & $conversationDetails': {
        flexBasis: '100%',
        width: '100%',
        maxWidth: 'none',
        flexShrink: '0',
        transform: 'translateX(0)'
      }
    }
  },
  openConversion: {
    '@media (max-width: 863px)': {
      '& $conversationList, & $conversationDetails': {
        transform: 'translateX(-100%)'
      }
    }
  },
  conversationList: {
    width: 300,
    flexBasis: 300,
    flexShrink: 0,
    overflowY: 'auto',
    '@media (min-width: 864px)': {
      borderRight: `1px solid ${theme.palette.divider}`
    }
  },
  conversationDetails: {
    flexGrow: 1
  },
  conversationPlaceholder: {
    flexGrow: 1
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

function Chat() {
  const classes = useStyles();
  const params = useParams();
  const [Loading, setLoading] = useState(true);
  const [conversations, setConversations] = useState([]);
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  const { t } = useTranslation('overview');
  let mounted = true;
const getData= ()=>{
  axios.get(`/GetSiriusComment/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}`).then((response) => {
    if (mounted) {
      if (response.data === '') {
        setYorumAdet(0);
        setConversations([]);
        setLoading(false);
      } else {
        setConversations(response.data);
        const Adet = response.data.length;
        setYorumAdet(Adet);
        setLoading(false);
      }
    }
  }).catch((error) => {
    setYorumAdet(0);
    setConversations({});
    setLoading(false);
  });
}
  useEffect(() => {
    getData()
    const intervalGetData = setInterval(getData, 10000)
    return () => {
      clearInterval(intervalGetData)
      mounted = false;
    };
  }, [SessionUser.ServiceShopId, SessionUser.TechnicianId]);

  let selectedConversation;
  if (params.id) {
    selectedConversation = conversations.find((c) => parseInt(c.ChatId) === parseInt(params.id));
  }

  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="xl">
        <Header title={t('lblCommentHistory')}/>
        {
          (conversations)
            ? (
              <Page
                className={clsx({
                  [classes.root]: true,
                  [classes.openConversion]: selectedConversation
                })}
                title={TitleApp}
              >
                {
                Loading
                  ? (
                    <Backdrop className={classes.backdrop} open={Loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  )
                  : <div />
              }
                <ConversationList
                  getData={getData}
                  className={classes.conversationList}
                  conversations={conversations}
                />
                {selectedConversation ? (
                  <ConversationDetails
                  getData={getData}
                    className={classes.conversationDetails}
                    conversation={selectedConversation}
                  />

                ) : (
                  <ConversationPlaceholder className={classes.conversationPlaceholder} />
                )}

              </Page>
            )
            : ''
        }
      </Container>
    </Page>
  );
}

export default Chat;
